export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
export const DATADOG = {
  APPLICATION_ID: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  CLIENT_TOKEN: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
};
export const EDEN_API_PATH = import.meta.env.VITE_EDEN_API_PATH;
export const PLATFORM_API_PATH = import.meta.env.VITE_PLATFORM_API_PATH;
export const GRAPH_QL_PATH = `${PLATFORM_API_PATH}/graphql/`;
export const REST_API_PATH = import.meta.env.VITE_REST_API_PATH;
export const SENTRY_STAGE = import.meta.env.VITE_SENTRY_STAGE;

export const DEBOUNCE_IN_MS = 500;
export const NO_END_DATE_TIMESTAMP = 4092624000000;
export const ERROR = {
  GENERIC: 'Something went wrong',
};
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const PER_PAGE = {
  SMALL: 25,
  MEDIUM: 100,
  LARGE: 250,
};

export const PROMO_DEFAULT_QUERIES =
  '?status=scheduled&status=live&sort_by=starts_at&sort_dir=desc';
export const PROMO_TEMPLATES_URL =
  'https://grocery-tv.notion.site/8b6537bf2b0243e0b4563e9dee53e1a5?v=5e25807492314eb9b2210e443706dd10';

export const SUPPORT_EMAIL = 'support@grocerytv.com';
